import type { FC } from 'react';
import { SEO_ORIGIN } from '@/base/constants';
import { useSettings } from '@/settings/api';
import { JsonLd } from './JsonLd';

const SITE_NAME = 'IQX';

// WebSite + SearchAction structured data. Rendered per-page (rather than baked
// into index.html) so the search target points at the active language.
export const WebsiteJsonLd: FC = () => {
  const [{ language }] = useSettings();

  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        url: SEO_ORIGIN,
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${SEO_ORIGIN}/${language}/price/{search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      }}
    />
  );
};
